export function mutationByKeyValue (state, payload) {
  payload.forEach(element => {
    state[element.key] = element.value
  })
}

// push용 socket instance set
export function setPushSocketInstance (state, payload) {
  state.pushSocketInstance = payload
}
